import { css } from 'lit';
export const badge = css `
  :host {
    --badge-size-small: 1.375rem; /* 22px */
    --badge-size-large: 2.875rem; /* 46px */

    display: inline-block;
  }

  .badge {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.125rem 0.375rem 0.0625rem;
    border-radius: 0.4375rem;
    font-family: var(--font-family-monument);
    font-size: var(--font-size-xs);
    font-weight: 400;
    gap: 0.313rem;
    box-sizing: border-box;
    overflow-wrap: anywhere;
  }

  .badge__prefix,
  .badge__suffix {
    flex: 0 0 auto;
    align-items: baseline;
  }

  /* -- badge SIZES -- */

  .badge--small {
    font-size: var(--font-size-xs);
    min-height: var(--badge-size-small);
    min-width: var(--badge-size-small);
  }

  .badge--small .badge__prefix {
    height: 0.886rem;
    width: 0.797rem;
  }

  .badge--large {
    font-size: var(--font-size-xs);
    min-height: var(--badge-size-large);
    min-width: var(--badge-size-large);
    gap: 0.525rem;
  }

  .badge--large .badge__prefix {
    height: 1.25rem;
    max-width: 1.25rem;
  }

  /* -- badge VARIANTS -- */

  .badge--primary {
    background: var(--primary-color);
    color: var(--primary-contrast-color);
  }

  .badge--secondary {
    background: var(--secondary-color);
    color: var(--secondary-contrast-color);
  }

  .badge--neutral {
    background: var(--neutral-color);
    color: var(--neutral-contrast-color);
  }

  .badge--info {
    background: var(--info-color);
    color: var(--info-contrast-color);
  }

  .badge--success {
    background: var(--success-color);
    color: var(--success-contrast-color);
  }

  .badge--warning {
    background-color: var(--warning-color);
    color: var(--warning-contrast-color);
  }

  .badge--error {
    background: var(--error-color);
    color: var(--error-contrast-color);
  }
`;
